import React, { FC, Fragment, useState, useEffect } from 'react';
import { Fade, LinearProgress } from '@mui/material';

const DelayedLinearProgress: FC = () => {
    const [showProgressBar, setShowProgressBar] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowProgressBar(true);
        }, 600);
        return () => {
            setShowProgressBar(false);
            clearTimeout(timer);
        };
    }, []);

    return (
        <Fragment>
            {showProgressBar ? (
                <Fade
                    in
                    style={{
                        transitionDelay: '100ms',
                    }}
                    unmountOnExit
                >
                    <LinearProgress color="secondary" />
                </Fade>
            ) : undefined}
        </Fragment>
    );
};

export default DelayedLinearProgress;
